import React from 'react'
import DataTable from '../../DataTable/DataTable'
import ReservationCardRecipients from './ReservationCardRecipients'
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

export default class ReservationCardEmail extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'emails',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="emails">
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t("sent_email")}</h3>
            <DataTable
                endpoint={this.props.sent_emails_data_table_path}
                no_data_text={I18n.t('none')}
                date_format={this.props.date_format}
                time_format={this.props.time_format} />
          </div>
        </div>

        {/* <hr /> */}
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t("scheduled_email")}</h3>
            <DataTable
                endpoint={this.props.scheduled_emails_data_table_path}
                no_data_text={I18n.t('none')}
                date_format={this.props.date_format}
                time_format={this.props.time_format} />
          </div>
        </div>
      </div>
    );
  }

  renderSentEmails() {
    var self = this;
    var emails = [];

    this.props.reservation.sent_emails.map(function(email) {
      emails.push(
        <tr key={email.id} className="email">
          <td>{DateHelper.parse(email.created_at).toString(self.props.date_format)} {I18n.t('at')} {DateHelper.parse(email.created_at).toString(self.props.time_format)}</td>
          <td>{email.subject}</td>
          <td><ReservationCardRecipients email={email} email_log_events={self.props.email_log_events} date_format={self.props.date_format} time_format={self.props.time_format} /></td>
          <td><a href={email.show_sent_email_body_path} className="modal-iframe" data-fullscreen="true">{I18n.t('view')}</a></td>
          <td><a href={email.resend_path} className="modal-iframe" data-fullscreen="true">{I18n.t('resend_email')}</a></td>
        </tr>
      )
    })

    return(
      <tbody className="emails">
        {emails}
      </tbody>
    )
  }

  renderScheduledEmails() {
    var self = this;
    var emails = [];

    this.props.reservation.scheduled_emails.map(function(email) {
      if (email.scheduled_at) {
        emails.push(
          <tr key={email.id} className="email">
            <td>{DateHelper.parse(email.scheduled_at).toString(self.props.date_format)}</td>
            <td>{email.subject ? email.subject : <span className="none">{I18n.t('none')}</span>}</td>
            <td>{email.to_addresses ? email.to_addresses : <span className="none">{I18n.t('none')}</span>}</td>
            <td>{email.cc_addresses ? email.cc_addresses : <span className="none">{I18n.t('none')}</span>}</td>
            <td>{email.bcc_addresses ? email.bcc_addresses : <span className="none">{I18n.t('none')}</span>}</td>
            <td><a href={email.show_email_body_templated_path} className="modal-iframe" data-fullscreen="true">{I18n.t('view')}</a></td>
          </tr>
        );
      }
    })

    return(
      <tbody className="emails">
        {emails}
      </tbody>
    )
  }

}
